import { getPriorityBadgeClass, getStatusBadgeClass } from "../../utils/badgeUtils";
const ApprovalsQueue = ({ data }) => ( 
   <div class="card shadow-sm">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h2 class="h6 mb-0">Approvals Queue</h2>
                {/* <span class="badge bg-danger-subtle text-danger border badge-status">
                  5 items
                </span> */}
              </div>
              <div class="list-group list-group-flush">
                 {data.map((a, i) => (
                    <div key={i} className="list-group-item list-group-item-action d-flex justify-content-between align-items-start">
                      <div>
                        <div className="fw-semibold">{a.title}</div>
                        <small class="text-muted">GST + Address verification</small>
                      </div>
                      <span className={getPriorityBadgeClass(a.priority)}>
                        {a.priority}
                      </span>
                    </div>
                  ))}                
              </div>
              <div class="card-footer text-end">
                <a href="/admin/approvals" class="small">Go to approvals</a>
              </div>
            </div>
);

export default ApprovalsQueue;
